<app-add-form
  [title]="formConfig.title"
  [formFields]="formConfig.formFields"
  [editMode]="false"
  [viewMode]="true"
  [initialData]="formattedPaymentData()"
  [headerActions]="formConfig.headerActions"
  (formAction)="onFormAction($event)"
></app-add-form>

<!-- Toast Messages -->
<p-toast></p-toast>
